export const PERIOD_OPTIONS = [
  { label: 'Ótimo', value: 'otimo' },
  { label: '6M', value: '6' },
  { label: '1A', value: '12' },
  { label: '2A', value: '24' },
  { label: '3A', value: '36' },
  { label: '5A', value: '60' },
];

export const TOOLTIP_CONTENT =
  'Para calcular a rentabilidade de um mês, como novembro de 2023 por exemplo, use 31/10/2023 como início e 30/11/2023 como fim. A rentabilidade mensal vai do mês anterior até o atual, e a anual do último dado do ano anterior até o mais recente do ano atual.';

export const TOOLTIP_GRAPHIC_CONTENT =
  'Ao ajustar o período dos dados do gráfico, você está modificando apenas o período do gráfico de rentabilidade. Isso não reflete nos dados exibidos como um todo.';

export const SIMPLE_PERIOD_OPTIONS = [
  { label: 'Completo', value: 'begin' },
  { label: 'No mês', value: 'mtd' },
  { label: 'No ano', value: 'ytd' },
  { label: '3 meses', value: 'last_3_months' },
  { label: '6 meses', value: 'last_6_months' },
  { label: '12 meses', value: 'last_12_months' },
  { label: '24 meses', value: 'last_24_months' },
  { label: '36 meses', value: 'last_36_months' },
  { label: '48 meses', value: 'last_48_months' },
];
